/**
 * @generated SignedSource<<cb201851b275d68c7c003e012dc9cd20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "removeUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "289cafc097a21863f3606c6f71116a8a",
    "id": null,
    "metadata": {},
    "name": "RemoveUserMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveUserMutation(\n  $userId: ID!\n) {\n  removeUser(userId: $userId) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "fe129cf9116af05eb50c1ffd950bb1b2";

export default node;
